<template>
  <!-- 一般的なSEO課題 -->
  <div v-if="proposal.content === 'MetaTitle'">
    全角文字32文字以下・半角文字64文字以下にメタタイトルタグを変更してみましょう。
  </div>
  <div v-else-if="proposal.content === 'MetaDescription'">
    全角文字120文字以下・半角文字240文字以下にメタディスクリプションタグを変更してみましょう。
  </div>
  <div v-else-if="proposal.content === 'Heading'">
    H1タグ・H2タグをページに設定しましょう。
  </div>
  <div v-else-if="proposal.content === 'HasRobot'">
    Webサイトにrobots.txtを設置しましょう。
  </div>
  <div v-else-if="proposal.content === 'HasSiteMap'">
    サイトマップを設置しましょう。
  </div>
  <div v-else-if="proposal.content === 'BrokenLink'">
    ページに存在する壊れたリンクを修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'BrokenImageLink'">
    リンク切れの画像タグを修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'BrokenStylesheetLink'">
    リンク切れのCSS読み込みタグを修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'BrokenScriptLink'">
    リンク切れのJavaScript読み込みタグを修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'CheckAlt'">
    alt属性が設定されていない画像タグを修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'DeprecatedHtmlTag'">
    ページに使用されている非推奨HTMLタグを修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'Favicon'">
    Webサイトにファビコンを設置しましょう。
  </div>
  <div v-else-if="proposal.content === 'JsError'">
    エラーが発生しているJavaScriptを修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'LinkSns'">
    ページにソーシャルメディアへのリンクを設置しましょう。
  </div>
  <!-- スピード最適化 -->
  <div v-else-if="proposal.content === 'HtmlSize'">
    HTMLのページサイズを33KB以内に収まるように修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'CompressedHtml'">
    Webサイトを公開しているサーバーが圧縮したHTMLで応答するように修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'SiteLoadingSpeedDesktop'">
    PCサイトの読み込み速度が4.3秒以内に収まるように修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'SiteLoadingSpeedMobile'">
    MOBILEサイトの読み込み速度が4.3秒以内に収まるように修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'OutBoundLink'">
    外部参照ファイル数が20個以下になるように修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'PageCache'">
    ページのキャッシュ設定を有効にしましょう。
  </div>
  <div v-else-if="proposal.content === 'UseFlash'">
    ページに設置されているFlashタグを修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'ImageCache'">
    画像キャッシュを有効にしましょう。
  </div>
  <div v-else-if="proposal.content === 'JsCache'">
    JavaScriptのキャッシュを有効にしましょう。
  </div>
  <div v-else-if="proposal.content === 'CssCache'">
    CSSのキャッシュを有効にしましょう。
  </div>
  <div v-else-if="proposal.content === 'JsMinify'">
    ページが読み込んでいるJavaScriptを縮小しましょう。
  </div>
  <div v-else-if="proposal.content === 'CssMinify'">
    ページが読み込んでいるCSSを縮小しましょう。
  </div>
  <div v-else-if="proposal.content === 'NestTable'">
    ネストされたテーブルタグを修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'UseFrame'">
    ページに設置されているframeタグを修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'Docktype'">
    ページにDoctype宣言を記述しましょう。
  </div>
  <div v-else-if="proposal.content === 'UrlRedirect'">
    ページのリダイレクト回数が1回以内に収まるように修正しましょう。
  </div>
  <!-- サーバー&セキュリテイ -->
  <div v-else-if="proposal.content === 'NormalizationUrl'">
    URLを正規化しましょう。
  </div>
  <div v-else-if="proposal.content === 'HttpsCheck'">
    ページのHTTPS化を行いましょう。
  </div>
  <div v-else-if="proposal.content === 'ServerSignature'">
    Webサイトを公開しているサーバーの署名をオフにしましょう。
  </div>
  <div v-else-if="proposal.content === 'DirectoryBrowsing'">
    Webサイトを公開しているサーバーのディレクトリ参照が無効にしましょう。
  </div>
  <div v-else-if="proposal.content === 'Email'">
    ページに平文で記述されているメールアドレスを修正しましょう。
  </div>
  <!-- モバイルユーザビリティ -->
  <div v-else-if="proposal.content === 'MediaQuery'">
    ページが読み込んでいるCSSがメディアクエリを使用したものになるように修正しましょう。
  </div>
  <!-- 高度なSEO -->
  <div v-else-if="proposal.content === 'StructuredData'">
    ページに構造化データをマークアップしましょう。
  </div>
  <div v-else-if="proposal.content === 'CanonicalCheck'">
    ページにcanonicalタグを設置しましょう。
  </div>
  <div v-else-if="proposal.content === 'CrawlAvoidance'">
    robots.txtにクロール回避の指示を記述しましょう。
  </div>
  <div v-else-if="proposal.content === 'UseHttp2'">
    WebサイトがHttp2に対応するように修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'NoIndexCheck'">
    ページに意図していないnoindex設定がされている場合は修正しましょう。
  </div>
  <div v-else-if="proposal.content === 'NoFollowCheck'">
    ページ内に設置されているリンクに、意図していないnofollow属性が設定されている場合は修正しましょう。
  </div>
</template>
<script>
export default {
  props: ['proposal']
};
</script>
